import React, { useState, useEffect, useContext } from 'react';
import { Link } from "react-router-dom";
import Plus7Header from "./Plus7Header";
import Plus7DetailsTab from "./Plus7DetailsTab";

function Plus7Wrap() {

    return (
        <>
            <div className="package-details-wrapper pt-110">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="tour-package-details">
                                <Plus7Header />
                                <Plus7DetailsTab />
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="package-sidebar">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Plus7Wrap;
